import { EventDataTypeEnum } from "../../../../../store/types/work.types";

export const UPLOAD_CONFIGS = {
  contract: {
    eventDataType: EventDataTypeEnum.SecureVolumeContractFile, // 74
    label: "Ladda upp avtal",
  },
  signed: {
    eventDataType: EventDataTypeEnum.SecureVolumeSignedContractFile, // 75
    label: "Ladda upp signerat avtal",
  },
} as const;

export type UploadVariant = keyof typeof UPLOAD_CONFIGS;
